import { env } from '../../env';

interface Manual {
  name: string;
  href: string;
}

export function getManuals() {
  const manuals = env.REACT_APP_MANUALS?.split('|').reduce((pers, curr) => {
    const [name = 'N/A', href = ''] = curr.replaceAll('_', ' ').split(',');

    if (href) {
      pers.push({
        name,
        href
      })
    }

    return pers
  }, [] as Manual[]) ?? [];

  return manuals
}

export default getManuals;